import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { SessionExpiryService } from '../services/session-expiry.service';

type ApiErrorBody = { error?: string; message?: string };

// Only acts on responses from our own API. Auth0 endpoints and any other
// outbound HTTP must be allowed to fail without forcing a logout.
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const sessionExpiry = inject(SessionExpiryService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        // Token expired or missing; bounce through Auth0 to refresh. The
        // service dedupes parallel 401s and remembers the current URL so we
        // land back here after re-auth.
        sessionExpiry.triggerReauth();
        return throwError(() => err);
      }

      if (err.status === 403) {
        const body = err.error as ApiErrorBody | null;
        const reason = body?.error ?? 'not-authorized';
        router.navigate(['/access-denied'], { queryParams: { reason } });
        return throwError(() => err);
      }

      return throwError(() => err);
    }),
  );
};
